import React from 'react'
import { Chip } from '@arnsbogroup/react-voicearchive'
import Icon from 'components/Icon'
import { FormattedMessage, useIntl } from 'react-intl'
import messages from './messages'

const ProjectVideo = ({}) => {
  return (
    <div className="bg-gray-50 block border-gray-300 border border-dashed relative w-full h-72 relative flex items-center justify-center">
      <Chip className="absolute top-0 right-0 -mr-4 -mt-2 z-40 text-white">
        <FormattedMessage {...messages.comingSoon} />
      </Chip>

      <Icon icon="play" className="text-2xl text-primary" />
    </div>
  )
}

export default ProjectVideo
